import React, { useEffect } from "react";
import { useSelector } from 'react-redux'
import { Link } from "react-router-dom";
function Success() {
    const message = useSelector(state => state.message)
    useEffect(() => {

    }, [message])
    return (
        <div className="jumbotron container">
            <h4>
            {
                message &&
                message.message
            }
            </h4>
            <p>
            <Link to='/'>
                Back
            </Link>
            </p>
        </div>
    )
}

export default Success
